import type { SceneLayoutContext } from '../../scenes/SceneComponent';

/** Where Fen and his speech board sit, for a screen and its reel frame. */
export interface FenPlacement {
  /** Fen's size (square). */
  size: number;
  /** Fen's top-left. */
  x: number;
  y: number;
  /** The speech board: its left edge, the y it hangs from, and its width. */
  bubble: { x: number; y: number; width: number };
  /** `left`: the board is beside Fen (phones); `below`: above him, its
   *  tail pointing down at him (wide screens). */
  tail: 'left' | 'below';
}

/**
 * Fen beside the reels when there's room (wide screens), his board above
 * him; on phones he stands in the reels' lower-left corner with his board
 * to his right, clear of the SPIN row.
 */
export function placeFen(ctx: SceneLayoutContext): FenPlacement {
  const left = ctx.machineLeft ?? 0;
  const right = ctx.machineRight ?? ctx.width;
  const size = Math.round(Math.max(96, Math.min(150, Math.min(ctx.width, ctx.height) * 0.26)));
  if (left >= size + 24) {
    const x = left - size - 8;
    const y = ctx.machineBottom - size;
    const width = Math.round(Math.min(340, left + (right - left) * 0.45 - 16));
    return { size, x, y, bubble: { x: 16, y: y - 12, width }, tail: 'below' };
  }
  const x = Math.max(2, left - 4);
  const y = ctx.machineBottom - size - 6;
  const bx = Math.round(x + size * 0.82);
  return { size, x, y, bubble: { x: bx, y: Math.round(y + size * 0.1), width: Math.round(Math.min(300, right - bx - 4)) }, tail: 'left' };
}
